import { useEffect } from "react";
import { useAuthNavigation } from "../hooks/useAuthNavigation";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const { user } = useAuthNavigation();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/dashboard", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [user, navigate]);

  return null; // No muestra nada porque redirige
};

export default Home;
